import { Container as ChakraContainer } from "@chakra-ui/react"

export default function Container({ maxW = '90%', mt = 10, children, ...props }){
    return <ChakraContainer maxW={maxW} mt={mt} children={children} {...props} />
}